<template>
    <div class="center">
        <div class="splash">
        <h1>{{ translation.STR_WELCOME }}</h1>
        <h2>{{ translation.STR_WELCOME2 }}</h2>
        </div>
    </div>
</template>
<style scoped>
.center {
    margin: auto;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-content: center;
    vertical-align: center;
    display: flex;
}
.splash {
    text-align: center;
    margin: auto;
}
h1 {
    font-weight: 100;
    font-size: 35pt;
    margin: 0px;
    padding: 0px;
}

h2 {
    font-weight: 100;
    font-size: 15pt;
    margin: 0px;
    padding: 0px;
}
</style>
<script>
export default ({
    props: [ 'translation'],
    mounted() {
        setTimeout(() => {
            if(this.$route.name == "pairing") return false;
            this.$router.push({
                name: 'StartScreen',
            })
        }, 2500)
    },
})
</script>
